<template>
  <div class="Notlar" v-if="Yetki>0">

    <el-tabs>
      <el-tab-pane v-if="data.Modul!='Duyuru'" :lazy=true>
        <span slot="label"><el-badge :value="NotAdet" class="m-badge">Notlar</el-badge></span>
        <div>
          <div class="NotDetay" v-for="Liste in NotListe">
            <p>{{ Liste.Icerik }}</p>
            <small><i class="el-icon-date"></i> {{ Liste.tarih }}</small>
            <small v-if="Liste.Kullanici"><i class="el-icon-user-solid"></i> {{ Liste.Kullanici }}</small>

            <a href="#" v-if="Yetki==2" @click="NotSilOnay(Liste.id)" class="text-danger"> <i
              class="el-icon-delete-solid"></i></a>

          </div>
        </div>
        <hr>
        <el-form v-if="Yetki==2" :model="NotForm" @submit.prevent.native="NotKaydet" :rules="FormHata"
                 ref="NotForm">
          <el-form-item label="Not" prop="Icerik">

            <el-input type="textarea" v-model="NotForm.Icerik"></el-input>
          </el-form-item>

          <el-button size="small" type="success" class="btn-block" @click="NotKaydet">Kaydet</el-button>
        </el-form>
      </el-tab-pane>
      <el-tab-pane :lazy=true>
        <span slot="label"><el-badge :value="DosyaAdet" class="m-badge">Dosyalar</el-badge></span>
        <el-tooltip class="item" effect="dark"
                    content="En fazla 2MB jpg/png/pdf/xls/xlsx/pdf dosyaları kabul eder"
                    placement="top-start">
          <el-upload
            v-if="Yetki==2"
            class="Upload"
            ref="upload"
            :action="UploadUrl"
            multiple
            accept=" .jpg, .jpeg, .png, .bmp, .pdf,.xls,.xlsx"
            :auto-upload="false"
            :file-list="DosyaListesi"
            :on-preview="DosyaGoster"
            :on-remove="DosyaSil"
            :on-success="DosyaIsle">
            <el-button class="btn-block" size="mini" type="default" slot="trigger"><i
              class="el-icon-link"></i> Dosya Seçiniz
            </el-button>

          </el-upload>
        </el-tooltip>
        <el-button v-if="Yetki==2" size="small" type="success" class="btn-block" @click="DosyaYukle"><i
          class="el-icon-upload2"></i> Yükle
        </el-button>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      loading: true,
      NotForm: {
        Icerik: null,
        Modul: this.data.Modul,
        Modul_id: this.data.Modul_id
      },
      Arsiv: {
        Dosya: null,
        Modul: this.data.Modul,
        Modul_id: this.data.Modul_id
      },
      FormHata: {
        Icerik: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
      },
      DosyaListesi: [],
      NotListe: [],
      UploadUrl: null,
      Yetki: null,
      NotAdet: null,
      DosyaAdet: null

    }
  },
  methods: {
    DosyaYukle() {
      this.$refs.upload.submit();
    },
    DosyaGoster(file) {
      window.open(file.url);
    },
    DosyaIsle(response, file, DosyaListesi) {
      if (response == 'done') {
        this.Arsiv.Dosya = file.name
        this.$store.dispatch("Post", {...this.Arsiv, path: 'spesiyal/arsiv'})
          .then(response => {
            if (response.Durum == "OK") {
              this.$message.success(response.Mesaj);
              //this.DosyaGetir()
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          })
      }
    },
    DosyaSil(file) {
      if (file.status == "success") {
        this.$store.dispatch("Delete", {...this.Form, path: 'spesiyal/arsiv/' + file.id})
          .then(response => {
            if (response.Durum == "OK") {
              this.$message.success(response.Mesaj);
              this.DosyaGetir();
            } else {
              this.$message.warning(response.Mesaj);
              this.hata = response.Hata;
            }
          })
      }

    },

    NotKaydet() {

      this.$refs['NotForm'].validate((valid) => {
        if (valid) {
          // EKLE
          this.$store.dispatch("Post", {...this.NotForm, path: 'spesiyal/not'})
            .then(response => {
              if (response.Durum == "OK") {
                this.$message.success(response.Mesaj);
                this.NotForm.Icerik = null
                this.NotGetir()
              } else {
                this.$message.error(response.Mesaj);
                this.hata = response.Hata;
              }
            })
        }

      });


    },
    DosyaGetir() {
      this.$store.dispatch("Get", {path: 'spesiyal/arsiv/' + this.data.Modul + '/' + this.data.Modul_id})
        .then(response => {
          if (response.Durum === 'OK') {
            this.DosyaListesi = response.Liste
            if (response.Liste) this.DosyaAdet = response.Liste.length; else this.DosyaAdet = null
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
    },
    NotGetir() {
      this.$store.dispatch("Get", {path: 'spesiyal/not/' + this.data.Modul + '/' + this.data.Modul_id})
        .then(response => {
          if (response.Durum === 'OK') {
            this.NotListe = response.Liste
            if (response.Liste) this.NotAdet = response.Liste.length; else this.NotAdet = null

            this.loading = false
          }
          if (response.Durum === 'NO') {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
    },
    NotSilOnay(id) {
      this.$confirm(this.$t('eGenel.1'), this.$t('eGenel.7'), {
        confirmButtonText: this.$t('eGenel.2'),
        cancelButtonText: this.$t('eGenel.3'),
        type: 'warning'
      }).then(() => {
        this.NotSil(id)
      }).catch(() => {
        this.$message.info(this.$t('eGenel.8'));
      });
    },
    NotSil(id) {
      this.$store.dispatch("Delete", {...this.Form, path: 'spesiyal/not/' + id})
        .then(response => {
          if (response.Durum == "OK") {
            this.$message.success(response.Mesaj);
            this.NotGetir();
          } else {
            this.$message.warning(response.Mesaj);
            this.hata = response.Hata;
          }
        })

    },

  },
  created() {
    this.UploadUrl = 'https://cdn.mudu.pro/Drive/' + this.$store.getters.HesapId + '/' + this.data.Modul;
    // this.Yetki = this.$store.getters.Yetki.NotArsiv;
    this.Yetki = 2;
    this.NotGetir();
    this.DosyaGetir();
  }

}
</script>



// WEBPACK FOOTER //
// src/components/Pack/Genel/Notlar.vue